/** German overlay for the IA restructure. */

const taxonomyDe = {
  family: 'Familie',
  families: {
    all_weather: 'Allwetter',
    directional: 'Direktional',
    market_neutral: 'Marktneutral',
    momentum: 'Momentum',
    high_octane: 'Hochoktan',
    intraday: 'Intraday',
  },
  familyCopy: {
    all_weather: 'Diversifizierte Regime-Portfolios. Geringeres Aktienbeta, langsamerer Pfad, Ballast für ein Portfolio.',
    directional: 'Index- und Makro-Timing. An Trends teilnehmen, aussteigen wenn die Marktgesundheit nachlässt.',
    market_neutral: 'Long/Short-Aktien mit Beta nahe null. Ein Diversifikator, kein Marktrufe.',
    momentum: 'US-Aktienmomentum über mehrere Horizonte. Folgt Stärke; bleibt in Mean-Reversion zurück.',
    high_octane: 'Gehebeltes Risk-on / Risk-off. Höhere Decke, tiefere Drawdowns.',
    intraday: 'Intraday Nasdaq-Futures. Systematische Einstiege innerhalb jeder Sitzung, flat zu ihrem Schluss. Nichts wird in die nächste Sitzung getragen; der Edge lebt im Volatilitätsregime.',
  },
};

export const iaDe = {
    nav: {
    portfolio: 'Portfolio',
    research: 'Analysen',
    reports: 'Berichte',
    quantLab: 'Quant-Labor',
    macroTerminal: 'Terminal',
    institutional: 'Institutionell',
    more: 'Mehr',
    account: 'Konto',
    login: 'Anmelden',
    about: 'Über mich',
    performance: 'Wertentwicklung',
  },
  taxonomy: taxonomyDe,
  disclaimer: {
    label: 'Hinweis',
    body: 'Backtest- und Research-Kapitalkurven sind Bildungsmaterial. Sie sind keine Anlageberatung und keine Empfehlung. Vergangene Performance garantiert keine zukünftigen Ergebnisse. Live-Trading enthält Kosten, die die Charts ignorieren.',
  },
  strategyDetail: {
    compare: 'In Performance vergleichen',
    portfolio: 'Zum Portfolio hinzufügen',
    subscribe: 'Wochenbericht',
    curveVsSpy: 'REBASIERTES EQUITY vs AKTIENINDEX = 100',
    pros: 'Warum es existiert',
    cons: 'Zielkonflikte',
    deepDive: 'Vollständige Analyse',
  },
  strategies: {
    kicker: 'SYSTEMATISCHE STRATEGIEN',
    colStrategy: 'STRATEGIE',
    volShort: 'VOL',
    modelsCtaTitle: 'Modellportfolios',
    modelsCtaBody: 'Fertige Mischungen dieser Strategien, mit derselben Engine wie der Portfolio-Builder.',
    openCard: 'Strategie öffnen →',
    intradayCardHint: 'Innen: Exposition wählen, 50 % bis 500 % des Kontos.',
    filterAll: 'Alle',
    liveBadge: 'LIVE',
    expandGroup: 'Alle {n} anzeigen ▸',
    collapseGroup: 'Weniger anzeigen ▴',
    seeFamily: 'Alle {n} ansehen →',
    sizing: {
      title: 'Intraday-Größe',
      exposure: 'Exposition',
      exposureHint: '{pct} des Kontos im Nasdaq, solange eine Position offen ist; die Zahl der Kontrakte folgt aus der Kontogröße.',
      wholeContracts: 'Kontrakte sind ganzzahlig: bei dieser Exposition braucht ein Kontrakt mindestens {min} Konto, und 100.000 $ würden heute {n} handeln.',
      grossNote: 'Vor Kommissionen und Slippage.',
    },
    variant: {
      label: 'Version',
      standard: 'Standard',
      ucits: 'UCITS',
      cardHint: 'Innen: Standard- oder UCITS-Version.',
      notes: {
        heimdall: 'UCITS ist der EU-Rahmen für Fonds, die an europäische Anleger vertrieben werden: dasselbe Signal, UCITS-fähige Instrumente und Konzentrationsgrenzen, in USD.',
        metis: 'UCITS ist der EU-Rahmen für Fonds, die an europäische Anleger vertrieben werden: dasselbe Signal, Gold und Rohstoffe mit je höchstens 20 %, der Rest in Liquidität, in USD.',
      },
    },
    strategyDescriptions: {
      tyr: 'Allwetter-Rotation',
      ares: 'Markt-Timing',
      ascalafo: 'Zwei Schichten',
      deimos: 'Timing + Risiko',
      fobos: 'Zwei Schichten + Risiko',
      bes: 'Trendfolge',
      janus: 'Marktneutral',
      hraesvelgr: 'Aggressives Allwetter',
      eos: 'Intraday Nasdaq-Futures',
      artemis: 'Ein Trade pro Sitzung',
      helios: 'Stündliche Trendfortsetzung',
      hyperion: 'Tagestrend, nur long',
      horai: 'Diversifiziertes Intraday-Programm',
      theia: 'Intraday-Programm, long und short',
      astraeus: 'Eine Entscheidung am Tag, in beide Richtungen',
      phaethon: 'Reitet den Schwung des Tages',
      hemera: 'Nach der Eröffnung, in beide Richtungen',
      selene: 'Geduldig, nur long',
      asteria: 'Einmal pro Woche, nur montags',
      aether: 'Breites Intraday-Programm',
      heimdall: 'Makro-Regime-Allokation',
      metis: 'Multi-Asset-Momentum-Rotation',
    },
    strategyFullDescriptions: {
      tyr: 'TYR ist eine diversifizierte Allwetter-Rotation. Sie verteilt Risiko über unkorrelierte Wirtschaftsregime und passt Exposures mit proprietären Signalen an. Benannt nach dem nordischen Gott der Ordnung und Disziplin.',
      ares: 'ARES ist systematisches Markt-Timing. Es liest die strukturelle Gesundheit des Marktes als Ganzes — nicht eines einzelnen Titels — und wechselt zwischen Risk-on und Risk-off. Validiert durch 2008, 2020 und 2022. Live auf Wikifolio.',
      ascalafo: 'ASCÁLAFO ist ein zweischichtiges Timing-System: unabhängige Signale müssen übereinstimmen, bevor das Exposure dreht. Dieselbe direktionale Familie wie ARES, mit engeren Einstiegen um Volatilitätsregime.',
      deimos: 'DEIMOS ist die Hochoktan-Timing-Hülse. Dieselbe Marktgesundheitslogik wie ARES, aggressiver wenn Trends sauber sind, härtere Drawdowns wenn nicht.',
      fobos: 'FOBOS legt ein Volatilitäts-Overlay auf gehebeltes Timing. Es reduziert Risiko, wenn Volatilitätsregime feindlich werden, und steigt wieder ein, wenn sie sich beruhigen.',
      bes: 'BES ist Aktienmomentum über mehrere Horizonte. Es behält Namen, die den breiten Markt auf mehreren Zeitskalen schlagen, und schneidet die, die das nicht tun.',
      janus: 'JANUS ist Long/Short marktneutrale Aktienauswahl. Wöchentliches Rebalancing, Beta nahe null: ein Diversifikator, kein Marktrufe.',
      hraesvelgr: 'HRÆSVELGR ist TYRs aggressiverer Zwilling in der Allwetter-Familie. Dieselbe Regime-Disziplin, mehr Appetit auf Wachstum und ein schnellerer Schwenk in die Defensive, wenn Momentum nachlässt.',
      eos: 'EOS ist nach der griechischen Göttin der Morgenröte benannt. Sie handelt Nasdaq-Futures in den ersten Stunden der Sitzung: ein systematischer, bestätigter Einstieg in die Richtung, zu der der Tag neigt, fester Stop und Ziel, flat vor dem Schluss. Mit YGGDRASIL geprüft: Sharpe nahe 1,5, Beta null zum Index. Dargestellt mit 300 % Exposition, vor Kommissionen.',
      artemis: 'ARTEMIS ist nach der griechischen Göttin der Jagd benannt: ein Pfeil pro Sitzung. Eine einzige systematische Position in Nasdaq-Futures früh in der Sitzung, long oder short, mit festem Stop und Ziel, flat zum Schluss; an den großen Makro-Tagen setzt sie aus. Geprüft mit einem festen Kontrakt: Sharpe 1,3, Beta null. Dargestellt mit 300 % Exposition, vor Kommissionen.',
      hyperion: 'HYPERION ist nach dem Titanen des Lichts benannt, der von oben wacht. Sie handelt Nasdaq-Futures intraday und nur long: Sie wartet, bis der Tag seine Karten zeigt, steigt mit festem Stop und Ziel ein und ist vor dem Schluss wieder draußen. Mit YGGDRASIL bei einem festen Kontrakt geprüft: Sharpe 1,4, Beta null. Dargestellt mit 300 % Exposition, vor Kommissionen.',
      helios: 'HELIOS ist nach der Sonne benannt, die über den Himmel zieht: sie folgt dem Weg, den der Tag nimmt. Einmal pro Stunde prüft sie, ob die Nasdaq-Futures mit Überzeugung in eine Richtung driften, und schließt sich dann dieser Bewegung mit festem Stop und Ziel an, höchstens ein paar Mal pro Sitzung, immer flat zum Schluss. Geprüft mit einem festen Kontrakt: Sharpe 1,1, Beta null. Dargestellt mit 300 % Exposition, vor Kommissionen.',
      horai: 'HORAI ist nach den griechischen Göttinnen der Stunden benannt, die den Tag unter sich aufteilen. Ein diversifiziertes Intraday-Programm auf Nasdaq-Futures: Das Konto verteilt sich auf unabhängige systematische Entscheidungen zu verschiedenen Zeitpunkten der Sitzung, alle flat zum Schluss. Diese Entscheidungen sind nur schwach korreliert, sodass der Großteil der Rendite mit einem Bruchteil des Drawdowns eines einzelnen Ansatzes erhalten bleibt. Dargestellt mit 300 % Exposition, vor Kommissionen.',
      theia: 'THEIA ist nach der Titanin des Sehens benannt, die den ganzen Tag auf einmal sieht. Ein systematisches Intraday-Programm auf Nasdaq-Futures, long und short, mit mehreren Entscheidungen über die Sitzung und nichts über Nacht. Mit YGGDRASIL geprüft. Dargestellt mit 300 % Exposition, vor Kommissionen.',
      astraeus: 'ASTRAEUS ist nach dem Titanen der Abenddämmerung benannt, Vater der Sterne und der vier Winde. Handelt Nasdaq-Futures intraday, long oder short, mit höchstens einer Entscheidung am Tag und nichts über Nacht. Mit YGGDRASIL bei einem festen Kontrakt geprüft: Sharpe 1,4, Beta null. Dargestellt mit 300 % Exposition, vor Kommissionen.',
      phaethon: 'PHAETHON ist nach dem Sohn des Helios benannt, der für einen Tag den Sonnenwagen nahm. Handelt Nasdaq-Futures intraday, long oder short, reitet den Schwung des Tages mit festem Stop und ist vor Schluss draußen. Mit YGGDRASIL bei einem festen Kontrakt geprüft: Sharpe 1,4, Beta null. Dargestellt mit 300 % Exposition, vor Kommissionen.',
      hemera: 'HEMERA ist nach der Göttin des Tages benannt, Tochter der Nacht, die jeden Morgen das Licht bringt. Handelt Nasdaq-Futures intraday, long oder short, sobald die Eröffnung ihre Karten gezeigt hat, mit festem Stop und Ziel und flach zum Schluss. Mit YGGDRASIL bei einem festen Kontrakt geprüft: Sharpe 1,3, Beta null. Dargestellt mit 300 % Exposition, vor Kommissionen.',
      selene: 'SELENE ist nach der Titanin des Mondes benannt, Schwester von Helios und Eos. Handelt Nasdaq-Futures intraday und nur long, an wenigen Tagen im Monat, die sie selbst wählt, und ist zum Schluss flach. Mit YGGDRASIL bei einem festen Kontrakt geprüft: nicht angenommen, eine harte Regel verfehlt. Dargestellt mit 300 % Exposition, vor Kommissionen.',
      asteria: 'ASTERIA ist nach der Titanin der Sternschnuppen benannt, Schwester der Leto, die zur Insel Delos wurde. Handelt Nasdaq-Futures nur long, einmal pro Woche: kauft am Sonntagabend für die Montagssitzung und ist vor dem Montagsschluss draußen, am festen Ziel oder nach der Uhr, ohne Stop. Mit YGGDRASIL bei einem festen Kontrakt geprüft: angenommen, Sharpe 1,3, keine harte Regel verfehlt; die Regel der Mindeststichprobe (300 Trades) wurde auf Entscheidung des Eigentümers abgeschaltet, weil sie nur einmal pro Woche handelt. Dargestellt mit 300 % Exposition, vor Kommissionen.',
      aether: 'AETHER ist nach der hellen oberen Luft benannt, die die Götter atmen, über dem Wetter. Ein systematisches Intraday-Programm auf Nasdaq-Futures, long und short, mit mehreren Entscheidungen über die Sitzung und flat zu jedem Schluss. Dargestellt mit 300 % Exposition, vor Kommissionen.',
      heimdall: 'HEIMDALL ist nach dem Wächter von Bifröst benannt, der alles sieht und alles hört und das Gjallarhorn bläst, wenn der Wandel kommt. Jeden Monat liest die Strategie Wachstum und Inflation in den USA aus den Daten, so wie sie damals veröffentlicht wurden, macht daraus die Wahrscheinlichkeiten von vier Regimen und verteilt das Portfolio auf Aktien, Treasuries, TIPS, Gold, Rohstoffe und T-Bills; ein wöchentliches Risiko-Overlay senkt die Exposition, wenn Volatilität oder Stress steigen. Zwei Versionen mit demselben Signal: Standard und UCITS. Die Standard-Version wurde mit YGGDRASIL geprüft: angenommen.',
      metis: 'METIS ist nach der Titanin des klugen Rates benannt, der ersten Frau des Zeus und Mutter der Athene. Am letzten Handelstag jedes Monats hält sie die drei von acht Märkten (Aktien, Treasuries, Gold, Rohstoffe, Immobilien), die in sechs Monaten am stärksten gestiegen sind, nur wenn sie im Plus sind, sonst Liquidität; eine Volatilitätsbremse senkt die Exposition über 15 %. Zwei Versionen mit demselben Signal: Standard und UCITS. Die Standard-Version wurde mit YGGDRASIL geprüft: angenommen. Die UCITS-Version wurde nicht angenommen (zwei harte Regeln verfehlt) und wird auf Entscheidung des Eigentümers veröffentlicht.',
    },
  },
  home: {
    ticker: {
      subtitle: 'Systematische Analysen · Live-Track-Record',
    },
    hero: {
      lead: 'Zweiundzwanzig systematische Strategien. Mehrere laufen seit Jahren live — Sie können ihnen auf Wikifolio, Darwinex und eToro folgen. Auf jeder Seite die Zahlen.',
      live: 'Live-Track-Record',
      ctaReports: 'Wochenberichte',
      ctaTerminal: 'Terminal öffnen',
    },
    regimeTeaser: {
      kicker: 'EIGENENTWICKLUNG',
      title: 'Der HMA-Regime-Detektor',
      body: 'Sechs Hidden-Markov-Modelle. Ein Komposit, walk-forward. Das Live-Desk darum herum. Abonnieren, um zu öffnen.',
      cta: 'Terminal ansehen',
    },
    featured: {
      subtitle: 'Direktional · Marktgesundheit',
      cta: 'ARES öffnen →',
      description: 'Markt-Timing aus einem Gesundheitskomposit: investiert bleiben, wenn die Lage es trägt, beiseite treten, wenn nicht. Live auf Wikifolio.',
    },
    families: {
      title: 'Sechs Familien',
      subtitle: 'Derselbe Research-Prozess, unterschiedliche Aufgaben in einem Portfolio. Öffnen Sie eine Familie, um die Strategien zu sehen.',
    },
    snapshot: {
      label: 'EQUITY, GLEICHER START',
      title: 'TYR vs Aktienindizes',
      hint: 'Gleiches Startdatum, auf 100 rebasiert. Log-Skala, damit TYR und die Indizes zusammen lesbar bleiben.',
      cta: 'Performance öffnen',
    },
    products: {
      title: 'Was Sie abonnieren können',
      reportsKicker: 'ANALYSEN',
      reportsTitle: 'Wochenberichte',
      reportsBody: 'Methodik, Portfolioentwicklung und die gerade geschlossene Woche — pro Strategie oder im Paket.',
      reportsCta: 'Pläne ansehen',
      terminalKicker: 'REGIME',
      terminalTitle: 'HMA Terminal',
      terminalBody: 'HMAs eigener Sechs-Faktoren-Regime-Detektor — plus das Live-Desk darum herum. Öffnen.',
      terminalCta: 'Terminal öffnen',
    },
    instTeaser: {
      title: 'Mandate, keine Produktseite',
      body: 'Strategiedesign, Regime-Research und Risiko-Overlays für Fonds, Family Offices und Desks, die einen Builder brauchen.',
      cta: 'Zur Mandatsseite',
    },
  },
  insights: {
    title: 'Analysen',
    subtitle: 'Quantitative Notizen auf Substack. Kalender und Regime-Engine leben im Terminal.',
    marketContext: 'Marktkontext',
    marketContextHint: 'Vollständiges Regime, STIR und Liquiditäts-Tools sind im Terminal.',
    openTerminal: 'Terminal öffnen',
    whereToInvestSubtitle: 'Mehrere Strategien laufen live, mit echtem Track Record auf regulierten Plattformen.',
    readOnSubstack: 'Auf Substack lesen →',
    strategyNamed: 'Strategie {name}',
  },
  weeklyReports: {
    revealPrice: 'Preis ansehen und abonnieren →',
    universeLabel: 'Universum',
    popular: 'Beliebt',
    universe: {
      diversified: 'Diversifizierte ETFs',
      index: 'Index-ETFs',
      equities: 'Notierte Aktien',
      leveraged: 'Gehebelte ETFs',
      futures: 'Nasdaq-Futures',
    },
    cards: {
      TYR: 'Allwetter-Regime-Rotation — wöchentlicher Research-Bericht',
      HRAESVELGR: 'Aggressive Allwetter-Rotation — wöchentlicher Research-Bericht',
      ARES: 'Makro-Timing und Absicherung — wöchentlicher Research-Bericht',
      JANUS: 'Long/Short marktneutral — wöchentlicher Research-Bericht',
      BES: 'Aktienmomentum über mehrere Horizonte — wöchentlicher Research-Bericht',
      ASCALAFO: 'Makro-Timing mit Volatilitäts-Overlay — wöchentlicher Research-Bericht',
      DEIMOS: 'Aggressives Makro-Timing — wöchentlicher Research-Bericht',
      FOBOS: 'Gehebeltes Timing mit Volatilitäts-Overlay — wöchentlicher Research-Bericht',
      EOS: 'Intraday Nasdaq-Futures — wöchentlicher Research-Bericht',
      ARTEMIS: 'Ein Trade pro Sitzung auf Nasdaq-Futures — wöchentlicher Research-Bericht',
      HELIOS: 'Stündliche Trendfortsetzung auf Nasdaq-Futures — wöchentlicher Research-Bericht',
      HYPERION: 'Tagestrend auf Nasdaq-Futures, nur long — wöchentlicher Research-Bericht',
      HORAI: 'Diversifiziertes Intraday-Programm auf Nasdaq-Futures — wöchentlicher Research-Bericht',
      THEIA: 'Intraday-Programm auf Nasdaq-Futures, long und short — wöchentlicher Research-Bericht',
      ASTRAEUS: 'Eine Entscheidung am Tag auf Nasdaq-Futures, long und short — wöchentlicher Research-Bericht',
      PHAETHON: 'Intraday-Momentum auf Nasdaq-Futures, long und short — wöchentlicher Research-Bericht',
      HEMERA: 'Nach der Eröffnung auf Nasdaq-Futures, long und short — wöchentlicher Research-Bericht',
      SELENE: 'Geduldige Long-Tage auf Nasdaq-Futures — wöchentlicher Research-Bericht',
      ASTERIA: 'Montags long auf Nasdaq-Futures, einmal pro Woche — wöchentlicher Research-Bericht',
      AETHER: 'Breites Intraday-Programm auf Nasdaq-Futures — wöchentlicher Research-Bericht',
      HEIMDALL: 'Multi-Asset-Allokation nach Makro-Regime, Standard und UCITS — wöchentlicher Research-Bericht',
      METIS: 'Multi-Asset-Momentum-Rotation, Standard und UCITS — wöchentlicher Research-Bericht',
    },
    disclaimerLabel: 'Hinweis',
    disclaimer: 'Diese Berichte dienen nur der Information und Bildung. Sie beschreiben Methodik, Modelle und die Portfolioentwicklung jeder Strategie. Sie sind KEINE Handelssignale, keine Anlageberatung und keine personalisierten Empfehlungen. Vergangene Performance garantiert keine zukünftigen Ergebnisse. Recherchieren Sie selbst und konsultieren Sie einen zugelassenen Berater, bevor Sie investieren.',
    notAvailable: 'Diese Strategie ist noch nicht kaufbar',
    bundleNotAvailable: 'Das Paket ist noch nicht kaufbar',
    checkoutFailed: 'Checkout-Sitzung konnte nicht erstellt werden',
    checkoutStartFailed: 'Checkout konnte nicht gestartet werden. Bitte erneut versuchen.',
  },
  checkout: {
    missingPrice: 'Dieses Produkt ist noch nicht kaufbar — Stripe-Preis fehlt.',
    checkoutFailed: 'Checkout konnte nicht gestartet werden',
    checkoutError: 'Checkout-Fehler: {message}',
    noSubscription: 'Kein aktives Abonnement gefunden',
    portalFailed: 'Abo-Verwaltung konnte nicht geöffnet werden. Bitte erneut versuchen.',
  },
  contact: {
    fillAll: 'Bitte alle Felder ausfüllen',
    sent: 'Nachricht gesendet. Ich antworte bald.',
    sendError: 'Fehler beim Senden. Bitte erneut versuchen.',
    connectionError: 'Verbindungsfehler. Später erneut versuchen.',
    sending: 'Senden…',
    methodLabel: 'Kontaktweg',
    methodHint: 'Nutzen Sie das Formular. Ich antworte in der Regel innerhalb von 24–48 Stunden.',
  },
  common: {
    present: 'Heute',
  },
  performancePage: {
    kicker: 'ANALYTIK',
    title: 'Wertentwicklung',
    lead: 'Vergleichen Sie Strategien untereinander und mit Aktienindizes. Sharpe, Drawdown, Korrelation und Risiko, aus den veröffentlichten Kurven.',
    dateRange: 'Datumsbereich',
    dateHint: 'Jede Serie wird auf die überlappenden Daten in diesem Bereich zugeschnitten und am gemeinsamen Start auf 100 rebasiert.',
    equity: 'Kapitalkurven',
    logScale: 'Log-Skala',
    showRegime: 'Marktregime-Overlay',
    regimeHint: 'Die Hintergrundfarbe ist das Sechs-Faktoren-Komposit (risk-on → risk-off). Eine marktweite Lesart, kein Strategiesignal.',
    regimeOn: 'Risk-on',
    regimeNeutral: 'Neutral',
    regimeCautious: 'Vorsichtig',
    regimeOff: 'Risk-off',
    rollingSharpe: 'Rollierender Sharpe',
    months: '{n} Monate',
    drawdown: 'Drawdown',
    underwater: 'unter Wasser',
    correlation: 'Korrelation',
    correlationHint: 'Monatsrenditen · Pearson',
    metrics: 'Vergleichskennzahlen',
    strategies: 'Strategien',
    benchmarks: 'Benchmarks',
    selectAll: 'Alle wählen',
    clear: 'Leeren',
    needTwo: 'Mindestens zwei Serien wählen, um Korrelationen zu sehen',
    needOne: 'Mindestens eine Serie wählen, um Kennzahlen zu sehen',
    needOneEquity: 'Mindestens eine Strategie oder Benchmark wählen',
    needOneDrawdown: 'Mindestens eine Serie wählen, um den Drawdown zu sehen',
    needOneSharpe: 'Mindestens eine Serie wählen, um den rollierenden Sharpe zu sehen',
    rebased: 'Auf 100 rebasiert',
    rebasedFrom: 'Auf 100 rebasiert · {date}',
    series: 'Serien',
    totalReturn: 'Gesamtrendite',
    volatility: 'Volatilität',
    upMonths: '% positive Monate',
    metricsNote: 'Kennzahlen werden über das überlappende Fenster der gewählten Serien berechnet',
    metricsNoteRange: 'innerhalb des markierten Datumsbereichs',
    metricsNoteAnnual: 'Sharpe und Sortino nutzen tägliche Überrenditen gegenüber 3-monatigen T-Bills, annualisiert mit 252 Handelstagen (Wochenkurven: Wochenrenditen, 52).',
    maxPreset: 'Max',
    typeStrategy: 'Strategie',
    typeBenchmark: 'Benchmark',
  },
  portfolioPage: {
    kicker: 'PORTFOLIO-BUILDER',
    title: 'Bauen Sie Ihr Portfolio',
    lead: 'Kombinieren Sie HMA-Strategien mit eigenen Gewichten, wählen Sie die Rebalancing-Frequenz und backtesten Sie das kombinierte Portfolio gegen die großen Benchmarks.',
    presets: 'Schnellvorlagen',
    loadModel: 'Modellportfolio laden',
    findProfile: 'Mein Risikoprofil finden',
    optimizing: 'Optimiere…',
    optimize: 'Auf max. Sharpe optimieren',
    optimizeFailed: 'Optimierung fehlgeschlagen — andere Rebalancing-Frequenz versuchen.',
    components: 'Portfolio-Komponenten',
    select: 'Wählen…',
    addComponent: 'Komponente hinzufügen',
    totalOk: 'Summe: {n}%',
    totalUnder: 'Summe: {n}% — {left}% übrig',
    totalOver: 'Summe: {n}% — übersteigt 100%',
    autoBalance: 'Auto-Balance',
    rebalancing: 'Rebalancing-Frequenz',
    rebalanceHint: 'Rebalancing setzt die Gewichte periodisch auf Ihre Zielallokation zurück.',
    monthly: 'Monatlich',
    quarterly: 'Vierteljährlich',
    annually: 'Jährlich',
    never: 'Nie (Kaufen und halten)',
    logScale: 'Log-Skala',
    rebased: 'Auf 100 rebasiert',
    calculate: 'Portfolio berechnen',
    copied: 'Kopiert!',
    copyLink: 'Link kopieren',
    models: 'Modellportfolios',
    modelsHint: 'Eine fertige Mischung laden, dann berechnen. Oder links selbst bauen.',
    myPortfolio: 'Mein Portfolio',
    allocation: 'Allokation',
    backtestRange: 'Backtest-Zeitraum',
    years: '{n} Jahre',
    rebalanced: 'Rebalancing: {freq}',
    equityCurve: 'Kapitalkurve',
    fullMetrics: 'Alle Kennzahlen',
    valueBase: 'Wert (Basis 100)',
    returnPct: 'Rendite (%)',
    sharpeRatio: 'Sharpe-Ratio',
    maxDrawdown: 'Max. Drawdown',
    ddDuration: 'DD-Dauer',
    bestYear: 'Bestes Jahr',
    worstYear: 'Schlechtestes Jahr',
    posMonths: 'Pos. Monate',
    compareVs: 'Vergleich mit',
    benchmarksHint: 'Gestrichelte Linien sind Referenzindizes. Sie sind nicht Teil des Portfolios.',
  },
  terminalLanding: {
    badge: 'PROPRIETÄRER REGIME-DETEKTOR',
    title: 'Ein Detektor für das Marktregime — selbst gebaut.',
    lead: 'Sechs Hidden-Markov-Modelle verdichten sich zu einem Komposit, von Risk-on bis Risk-off. Darum herum das Live-Desk: Makro, Funding, Internals. Täglich öffnen.',
    price: '10,99 € / Monat.',
    ctaSignIn: 'Anmelden zum Abonnieren',
    ctaOpen: 'Terminal öffnen →',
    ctaBusy: 'Weiterleitung…',
    ctaUnlock: 'Freischalten für 10,99 € / Monat',
    seeInside: 'Den Detektor sehen',
    subscribed: 'Sie sind abonniert — der Zugang ist aktiv.',
    liveNow: 'LIVE-KOMPOSIT',
    liveAsOf: 'Stand {date}',
    regimeEyebrow: 'DIE ENGINE',
    regimeTitle: 'Der HMA-Regime-Detektor',
    regimeLead: 'Das ist der proprietäre Kern des Terminals. Sechs unabhängige gaußsche HMMs — Volatilität, Trend, Breite, Zyklus, Liquidität, Bewertung — jedes inferiert einen latenten Zustand und ein posterior-gewichtetes Risiko. Ihr Gleichgewichtsmittel ist das Komposit. Jeder Tag walk-forward: nur Informationen bis zu diesem Tag. Kein Trade-Ticket. Eine Lesung des Tapes.',
    regimePoints: [
      { t: 'Eigenentwicklung', d: 'Hier entworfen und betrieben. Dieselbe Engine, mit der HMA den Markt liest — jetzt auf Ihrem Bildschirm.' },
      { t: 'Sechs Faktoren', d: 'Volatilität, Trend, Breite, Zyklus, Liquidität, Bewertung. Unabhängige Modelle, ein Komposit.' },
      { t: 'Walk-forward', d: 'Kein Look-ahead. Jeder Tag wird auf seiner eigenen Vergangenheit gefiltert. Eine Historie, der man vertrauen kann.' },
      { t: 'Komposit und Exposure', d: 'Eine Zahl von 0 (Risk-on) bis 1 (Risk-off). Vorgeschlagenes Exposure = 1 − Komposit, mit 5-Tage-Hysterese.' },
    ],
    shotsEyebrow: 'DAS DESK',
    shotsTitle: 'Was Sie nach dem Abo öffnen',
    shots: [
      { t: 'Regime-Detektor', d: 'Komposit, Sechs-Faktoren-Board, kausale Historie.' },
      { t: 'Liquiditäts-Tape', d: 'Nettoliquidität, Overnight-Sätze, die Kurve.' },
      { t: 'STIR-Monitor', d: 'Korridor, Reserven, Funding-Stress.' },
      { t: 'Makro-Dashboard', d: 'Renditen, Inflation, Arbeit, Kredit, Stress.' },
      { t: 'Marktinterne', d: 'Partizipation unter dem Index.' },
      { t: 'Privates Repo', d: 'Overnight-Sätze, Volumina, Facility-Nutzung.' },
    ],
    lockedEyebrow: 'GESPERRT',
    lockedTitle: 'Mehr Panels, hinter dem Schloss',
    lockedHint: 'Abonnieren, um Faktoren-Explorer, Kredit, Facilities und Breadth-Alerts zu öffnen — nicht nur die Cover.',
    lockedCta: 'Freischalten',
    lockedShots: [
      { t: 'Faktoren-Explorer' },
      { t: 'Kredit und Stress' },
      { t: 'Facility-Nutzung' },
      { t: 'Breadth-Alerts' },
      { t: 'Feldleitfaden' },
      { t: 'Overnight-Funding' },
      { t: 'Faktoren-Historie' },
      { t: 'Liquidität nah' },
    ],
    previewKicker: 'LIVE-VORSCHAU',
    previewTitle: 'Das echte Terminal läuft darunter. Abonnieren, um den Blur zu heben.',
    insideEyebrow: 'WAS SIE BEKOMMEN',
    insideTitle: 'Der Detektor, dann das ganze Desk',
    features: [
      { t: 'HMA-Regime-Detektor', d: 'Sechs unabhängige gaußsche Hidden-Markov-Modelle. Ein Komposit von Risk-on bis Risk-off. Hier gebaut, nicht lizenziert.' },
      { t: 'Komposit und Exposure', d: 'Eine Zahl von 0 bis 1, vorgeschlagenes Exposure 1 − Komposit, und 5-Tage-Hysterese, damit das Label nicht flackert.' },
      { t: 'Walk-forward-Historie', d: 'Jeder Tag mit Informationen bis zu diesem Tag bewertet — kein Look-ahead. Ein Regime-Pfad zum Backtesten.' },
      { t: 'Faktoren-Explorer', d: 'Jeden Faktor öffnen: Live-Zustand, Risikopfad und die Indikatoren, die das Modell speisen.' },
      { t: 'Liquiditäts-Tape', d: 'System-Nettoliquidität vs Aktienindex, Overnight-Sätze und die 2s10s-Kurve — die Tide auf einem Schirm.' },
      { t: 'STIR-Monitor', d: 'Overnight-Korridor, Tails, Reserven vs Reverse-Repo, Funding-Spreads und Geldmarkt-Assets — wo Stress zuerst auftaucht.' },
      { t: 'Marktinterne', d: '4%-Beweger, 5- und 10-Tage-Ratios, 25-Tage-Hochs/Tiefs und der 13/34-Thrust — nicht nur der Index.' },
      { t: 'Makro-Dashboard', d: 'Volle Zinskurve, Inflation und Arbeit, HY vs IG Kredit, Finanzkonditionen, Dollar und Öl.' },
      { t: 'Privates Repo', d: 'Tri-Party-, DVP- und GCF-Overnight-Sätze und Volumina, neben Facility-Nutzung und Counterparties.' },
      { t: 'Feldleitfaden', d: 'Klare Notizen zu jeder Serie: was sie bedeutet, warum sie sich bewegt, und wie man sie liest.' },
    ],
    howEyebrow: 'SO FUNKTIONIERT ES',
    howTitle: 'Der Detektor bewertet den Tag. Sie lesen ihn.',
    steps: [
      { n: '01', t: 'Sechs Modelle bewerten heute', d: 'Jeder Faktor inferiert einen latenten Zustand und ein Risiko in [0,1] — strikt kausal, kein Look-ahead.' },
      { n: '02', t: 'Ein Komposit', d: 'Gleichgewichtetes Mittel, Hysterese, vorgeschlagenes Exposure. Risk-on bis Risk-off, in einer Zahl.' },
      { n: '03', t: 'Sie öffnen das Terminal', d: 'Der Detektor, die Historie, der Explorer und der Rest des Desks — bereit nach dem Login.' },
    ],
    membership: 'MITGLIEDSCHAFT',
    perMonth: '/ Monat',
    cancel: 'Jederzeit kündbar · monatliche Abrechnung',
    bullets: [
      'Proprietärer Sechs-Faktoren-Regime-Detektor',
      'Live-Komposit und vorgeschlagenes Exposure',
      'Walk-forward-Regime-Historie',
      'Faktoren-Explorer',
      'Makro-, STIR-, Internals- und Repo-Panels',
      'Feldleitfaden zu jeder Serie',
      'Tägliche Updates',
    ],
    faqEyebrow: 'Häufige Fragen',
    faqTitle: 'Gut zu wissen',
    faq: [
      { q: 'Wofür zahle ich genau?', a: 'Live-Zugang zum Terminal: HMAs proprietärer Regime-Detektor, der Faktoren-Explorer, die kausale Historie und der Rest des Desks — täglich aktualisiert.' },
      { q: 'Was ist der Regime-Detektor?', a: 'Eine Sechs-Faktoren-Hidden-Markov-Engine, hier gebaut. Sie sagt nicht, was Sie kaufen sollen. Sie sagt den Risikozustand des Marktes, jeden Tag, ohne Look-ahead.' },
      { q: 'Ist das Anlageberatung?', a: 'Nein. Es ist ein quantitatives Research- und Monitoring-Werkzeug. Alles ist Bildung und Information — keine Empfehlung, etwas zu kaufen oder zu verkaufen.' },
      { q: 'Kann ich jederzeit kündigen?', a: 'Ja. Es ist ein Monatsabo, das Sie mit einem Klick im Konto kündigen; der Zugang läuft bis zum Ende der Abrechnungsperiode.' },
    ],
    disclaimer: 'Das hmaquant Terminal ist ein quantitatives Research- und Monitoring-Werkzeug zu Bildungs- und Informationszwecken. Es ist keine Anlageberatung und nichts darin ist eine Empfehlung, ein Wertpapier zu kaufen oder zu verkaufen.',
  },
  reportsFaq: {
    title: 'Häufige Fragen',
    items: [
      { q: 'Was kaufe ich?', a: 'Einen wöchentlichen Research-Bericht zu dieser Strategie: Methodik, Portfolioentwicklung und die Vorwoche. Kein Trade-Ticket und keine personalisierte Beratung.' },
      { q: 'Kann ich kündigen?', a: 'Ja. Verwalten Sie das Abo in Ihrem Konto. Der Zugang läuft bis zum Ende der Abrechnungsperiode.' },
      { q: 'Was ist der Jahresplan?', a: 'Zehn Monate berechnet, zwei Monate frei. Derselbe Bericht, jährliche Rechnung.' },
      { q: 'Enthält das Paket das Terminal?', a: 'Das Paket umfasst die zweiundzwanzig Strategieberichte und Makro-Notizen. Das Terminal ist ein separates Produkt für 10,99 €.' },
    ],
  },
  footer: {
    tagline: 'Systematisches Research. Zweiundzwanzig Strategien, ein Prozess.',
    intradayNote: 'Die Kurven der Intraday-Futures-Strategien (EOS, ARTEMIS, HELIOS, HYPERION, HORAI, THEIA, ASTRAEUS, PHAETHON, HEMERA, SELENE, ASTERIA, AETHER) sind vor Kommissionen und Slippage dargestellt, mit einer konstanten Exposition von 300 % des Kontos (die Kontrakte folgen der Kontogröße), auf einem Backtest, der aus der YGGDRASIL-Prüfung repliziert wurde.',
  },
  accountHub: {
    reports: 'Meine Berichte',
    terminal: 'Terminal',
    lab: 'Quant-Labor',
  },
  quantLabPage: {
    kicker: 'SANDBOX',
    blurb: 'Bildungs-Simulationen — GBM, Mean Reversion, Hidden Markov, Greeks. Nicht das Live-Desk.',
    openTerminal: 'Terminal öffnen',
    versionBar: 'QUANT LAB v1.0 · HMA QUANT STRATEGIES',
  },
  terminalChrome: {
    lab: 'Bildungs-Sandbox · keine Anlageberatung',
    modules: '{n} Module',
  },
  institutionalPage: {
    kicker: 'MANDATE',
    heroTitle: 'Für Ihr Book gebaut. Kein Produktkatalog.',
    heroBody: 'HMA übernimmt institutionelle Research-Mandate — systematisches Design, Regime-Arbeit und Risiko-Overlays — für Fonds, Family Offices und Desks, die einen Builder brauchen, keinen weiteren Newsletter.',
    ctaPrimary: 'Mandat skizzieren',
    ctaSecondary: 'So arbeiten wir',
    proofKicker: 'ÖFFENTLICH',
    proof: [
      { value: '12', label: 'systematische Strategien live' },
      { value: 'Live', label: 'Track Record auf Wikifolio, Darwinex und eToro' },
      { value: '6 HMM', label: 'eigene Regime-Engine, walk-forward' },
      { value: 'Desk', label: 'Physik, Quantitative Finance, Buy-Side und Broker' },
    ],
    forTitle: 'Wer schreiben sollte',
    forBody: 'Wenn Sie die Frage schon kennen, können wir in einem Call den Scope ziehen. Wenn Sie eine Vendor-Broschüre brauchen, ist das die falsche Seite.',
    for: [
      { title: 'Family Office / Allocator', body: 'Ein Sleeve, der sich neben dem Rest des Books verdienen muss. Wir designen Prozess, Risikobudget und Kill-Switch — kein Pitch-Deck aus Backtests.' },
      { title: 'CIO / Risiko', body: 'Ein Regime-Overlay, ein Drawdown-Protokoll oder ein unabhängiger Blick, ob das aktuelle Book noch das Book ist, das Sie dachten zu haben.' },
      { title: 'Systematisches Desk', body: 'Ein Modul, das Sie nicht intern staffen wollen: Signal-Research, Walk-forward, Monitoring-Spec oder ein zweites Paar Augen auf einen Live-Prozess.' },
    ],
    workTitle: 'Mandate, die wir annehmen',
    workBody: 'Die öffentliche Site ist das Work Sample. Ein Mandat geht weiter: Ihre Daten, Ihre Constraints, Ihr Book.',
    work: [
      { title: 'Systematisches Strategiedesign', body: 'Von der Hypothese zu einem Prozess, den Sie fahren können. Universum, Signale, Execution-Annahmen, Walk-forward und die Failure Modes, bevor Kapital Risiko trägt.', tag: 'Neuer Sleeve · Rebuild' },
      { title: 'Regime- und Makro-Research', body: 'Der Sechs-HMM-Stack aus dem Terminal, auf Ihr Book spezifiziert: wann Risiko dazu, wann schneiden, was neutral für Sie heißt.', tag: 'Overlay · Timing' },
      { title: 'Risiko-Overlays und Drawdown-Protokolle', body: 'Kill-Switches, Vol-Targeting, Stresspfade und Regeln, die ein CIO im Komitee verteidigen kann — keine VaR-Zahl auf einer Folie.', tag: 'Risiko · Overlay' },
      { title: 'Portfoliokonstruktion', body: 'Wie die Teile zusammenstehen. Risikobudgets, Korrelationsregime, und was tun, wenn zwei Diversifier sich wie einer bewegen.', tag: 'Family Office · Multi-Strategy' },
      { title: 'Research auf Retainer', body: 'Wöchentliche oder monatliche Kadenz: Notizen, Diagnosen und jemand, der das Book schon kennt. Näher am Desk als am Consulting-PDF.', tag: 'Laufend' },
    ],
    processTitle: 'So läuft ein Engagement',
    processBody: 'Kurzer Scope, schriftliche Annahmen, die Arbeit bleibt bei Ihnen.',
    process: [
      { n: '01', title: 'Brief', body: 'Sie schicken die Frage, die Constraints und was done heißt. Wir sagen ja, nein oder noch nicht.' },
      { n: '02', title: 'Scope', body: 'Eine kurze Notiz: Deliverables, benötigte Daten, Timeline, Fee. Keine Fishing Expedition.' },
      { n: '03', title: 'Build', body: 'Research offen mit Ihnen. Code, Charts und Annahmen so geschrieben, dass jemand anderes sie neu laufen lassen könnte.' },
      { n: '04', title: 'Übergabe', body: 'Die Arbeit bleibt bei Ihnen. Optionaler Retainer, damit der Prozess mit dem Regime lebt.' },
    ],
    deliverTitle: 'Was Sie mitnehmen',
    deliver: [
      { title: 'Ein geschriebener Prozess', body: 'Keine Black Box. Signale, Daten und die Regeln, wann gehandelt werden darf.' },
      { title: 'Ein Research-Pack', body: 'Walk-forward, Failure Cases und Charts, die ein Komitee wirklich lesen kann.' },
      { title: 'Code, wenn Sie ihn wollen', body: 'Reproduzierbare Notebooks oder ein kleiner Service. Zum Selbstfahren.' },
      { title: 'Eine Operating-Spec', body: 'Was monitoren, was killen, wer den Alert bekommt.' },
    ],
    notTitle: 'Was das nicht ist',
    notItems: [
      'Wir lagern Ihr AUM nicht ein. Der Live-Track-Record steht auf regulierten Plattformen — Beweis für den Prozess, kein Fundraise.',
      'Wir verkaufen keinen Signal-Dump und kein Modell ohne Owner.',
      'Wir nehmen nicht jeden Brief. Ist es ein Newsletter, ist die Reports-Seite das Produkt. Ist es ein Desk-Problem, schreiben Sie.',
    ],
    sampleTitle: 'Das öffentliche Work Sample',
    sampleBody: 'Strategien, Performance und das Terminal sind, was wir schon fahren. Ein Mandat ist dasselbe Handwerk, auf Sie spezifiziert.',
    samples: [
      { to: '/strategies', label: 'Zweiundzwanzig Strategien' },
      { to: '/performance', label: 'Performance' },
      { to: '/terminal', label: 'Regime-Desk' },
    ],
    formKicker: 'INTAKE',
    formTitle: 'Kurzen Brief senden',
    formBody: 'Firma, das Problem, die Constraint. Wir antworten selbst.',
    formName: 'Name',
    formFirm: 'Firma',
    formEmail: 'E-Mail',
    formNeed: 'Was Sie brauchen',
    formNeedPlaceholder: 'Mandat wählen',
    formMessage: 'Der Brief',
    formSend: 'Brief senden',
    formSending: 'Senden…',
    formOk: 'Angekommen. Wir melden uns.',
    formErr: 'Senden hat hier nicht geklappt — nutzen Sie den Mail-Link, dann kommt es trotzdem an.',
    formMail: 'Per E-Mail schreiben →',
    formNote: 'Vertraulich. Keine Sales-Queue. Wenn der Brief nicht passt, sagen wir das.',
    needs: [
      { id: 'strategy', label: 'Strategiedesign' },
      { id: 'regime', label: 'Regime / Overlay' },
      { id: 'risk', label: 'Risiko / Drawdown-Protokoll' },
      { id: 'portfolio', label: 'Portfoliokonstruktion' },
      { id: 'retain', label: 'Research auf Retainer' },
      { id: 'other', label: 'Etwas anderes — ich erkläre' },
    ],
    ctaLine: 'Wenn die Frage Sie schon wachhält, schreiben Sie sie auf.',
  },
};
